(function () {
  var style = document.createElement('style');
  style.textContent = '.slideshow__slide { cursor: pointer; } .slideshow__slide .banner__content { display: none !important; } .slideshow.scroll-trigger { pointer-events: none !important; } .slideshow.scroll-trigger .slideshow__slide { pointer-events: auto !important; }';
  document.head.appendChild(style);

  document.addEventListener('click', function (event) {
    var slide = event.target.closest('.slideshow__slide');
    if (!slide) return;
    var link = slide.querySelector('.banner__buttons a.button');
    if (!link) return;
    var href = link.getAttribute('href');
    if (!href) return;
    window.location.href = href;
  });
})();
